import React from 'react';
// Un utilitaire JavaScript simple pour joindre de manière conditionnelle des noms de classe
import classNames from 'classnames';
// Une bibliothèque de dates JavaScript pour l'analyse, la validation, la manipulation et le formatage des dates
import Moment from 'react-moment';
import { Link } from 'react-router-dom';

export default function LaunchItem({
    launch: { id, name, date_local, success }
}) {
    return (
        <div className="card card-body mb-3  opacity-4">
            <div className="row">
                <div className="col-md-9">
                    <h4>
                        Mission: {''}
                        <span
                            className={classNames({
                                'text-success': success,
                                'text-danger': !success
                            })}
                        >
                            {name}
                        </span>
                    </h4>
                    <p>Date: {''}<Moment format="YYYY-MM-DD HH:mm">{date_local}</Moment></p>
                </div>
                <div className="col-md-3 mt-4">
                    {/* <div>{id}</div> */}
                    <Link to={`/launch/${id}`} className="shadow-sm btn btn-secondary">Launch Details</Link>
                </div>
            </div>
        </div>
    );
};
